<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $t('messages.usage_information'),
                        href: meta.links.usage_stats_index,
                    },
                    {
                        name: $tc('messages.activities', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="flex gap-2 flex-wrap">
            <NavLinks :links="meta.navLinks.stages" />
            <NavLinks :links="meta.navLinks.trimester" />
        </div>

        <div class="flex flex-col mt-3">
            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead>
                                <tr>
                                    <th
                                        v-for="header in gradesCountTable.header"
                                        class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        {{ header }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="bg-white divide-y divide-gray-200">
                                <tr v-for="row in gradesCountTable.body">
                                    <td
                                        v-for="cell in row"
                                        class="px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                                    >
                                        <span :class="{ 'text-gray-300': cell == 0 }">
                                            {{ cell }}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="md:grid md:grid-cols-3 md:gap-6 mt-5">
            <div class="relative col-span-1 flex shadow rounded-md" v-for="teacher in teachers" :key="teacher.id">
                <div
                    class="shrink-0 flex items-center justify-center w-24 text-white text-sm leading-5 font-medium rounded-l-md overflow-hidden"
                >
                    <InertiaLink href="teacher.links.show">
                        <img :src="teacher.avatar_or_default" alt="profile photo" />
                    </InertiaLink>
                </div>
                <div
                    class="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate"
                >
                    <div class="flex-1 px-4 py-2 text-sm leading-5 truncate">
                        <InertiaLink
                            :href="teacher.links.show"
                            class="text-gray-900 font-medium hover:text-gray-600 transition ease-in-out duration-150"
                        >
                            {{ teacher.full_name }}
                        </InertiaLink>
                        <div class="text-xs">
                            <div>
                                {{ $tc('messages.activities', teacher.activities_count) }}:
                                {{ teacher.activities_count }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import NavLinks from '@/components/NavLinks.vue';
import PanelPage from '@/Shared/PanelPage.vue';

export default {
    components: {
        PanelPage,
        NavLinks,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'teachers', 'gradesCountTable'],
    data() {
        return {};
    },
    methods: {},
};
</script>
